import PageHeader from "@/components/PageHeader";
import Services from "@/sections/Services";
import EmergencyBanner from "@/sections/EmergencyBanner";
import PageCTA from "@/components/PageCTA";

const ServicesPage = () => {
  return (
    <>
      <PageHeader
        tag="/ Services"
        title="OUR"
        accent="SERVICES."
        subtitle="From a dripping tap at midnight to a full bathroom install — we cover the full scope of domestic and commercial plumbing and drainage across Edinburgh and the Lothians."
      />
      <EmergencyBanner />
      <Services />
      <PageCTA />
    </>
  );
};

export default ServicesPage;
